// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dropdown_overlay__1CKbW"};